import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var _templateObject = taggedTemplateLiteral(['\n  display: flex;\n  position: relative;\n  transition: transform 1s;\n  border-radius: 50%;\n  box-sizing: content-box;\n  ', '\n'], ['\n  display: flex;\n  position: relative;\n  transition: transform 1s;\n  border-radius: 50%;\n  box-sizing: content-box;\n  ', '\n']),
    _templateObject2 = taggedTemplateLiteral(['\n    background-color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n    transform: rotate(', ');\n    border: ', ';\n  '], ['\n    background-color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n    transform: rotate(', ');\n    border: ', ';\n  ']),
    _templateObject3 = taggedTemplateLiteral(['\n  width: 100%;\n  overflow: hidden;\n  opacity: ', ';\n  ', '\n'], ['\n  width: 100%;\n  overflow: hidden;\n  opacity: ', ';\n  ', '\n']),
    _templateObject4 = taggedTemplateLiteral(['\n      transform: scaleX(-1);\n    '], ['\n      transform: scaleX(-1);\n    ']),
    _templateObject5 = taggedTemplateLiteral(['\n  position: absolute;\n  z-index: 1;\n  left: 50%;\n  background: ', ';\n  ', '\n'], ['\n  position: absolute;\n  z-index: 1;\n  left: 50%;\n  background: ', ';\n  ', '\n']),
    _templateObject6 = taggedTemplateLiteral(['\n    width: ', 'px;\n    height: ', 'px;\n    border-radius: 50%;\n    transform: translateX(-50%) rotateY(', 'rad);\n  '], ['\n    width: ', 'px;\n    height: ', 'px;\n    border-radius: 50%;\n    transform: translateX(-50%) rotateY(', 'rad);\n  ']),
    _templateObject7 = taggedTemplateLiteral(['\n  ', '\n  border-radius: 50%;\n'], ['\n  ', '\n  border-radius: 50%;\n']),
    _templateObject8 = taggedTemplateLiteral(['\n    width: ', 'px;\n    height: ', 'px;\n    background-color: ', ';\n  '], ['\n    width: ', 'px;\n    height: ', 'px;\n    background-color: ', ';\n  ']);

var Wrapper = styled.div(_templateObject, function (_ref) {
  var size = _ref.size,
      rotation = _ref.rotation,
      darkColor = _ref.darkColor,
      border = _ref.border;
  return css(_templateObject2, darkColor, size, size, rotation, border);
});

var Half = styled.div(_templateObject3, function (_ref2) {
  var isVisible = _ref2.isVisible;
  return isVisible ? 1 : 0;
}, function (_ref3) {
  var invert = _ref3.invert;
  return invert && css(_templateObject4);
});

var getNormalizedPhase = function getNormalizedPhase(phase) {
  return phase <= 0.5 ? phase : 1 - phase;
};

var getRotationRad = function getRotationRad(phase) {
  var normalizedPhase = getNormalizedPhase(phase);
  var rad = Math.PI * normalizedPhase / 0.5;
  return rad;
};

var Difference = styled.div(_templateObject5, function (_ref4) {
  var phase = _ref4.phase,
      darkColor = _ref4.darkColor,
      lightColor = _ref4.lightColor;
  return 0.5 / getNormalizedPhase(phase) > 2 ? darkColor : lightColor;
}, function (_ref5) {
  var size = _ref5.size,
      phase = _ref5.phase;
  return css(_templateObject6, size, size, getRotationRad(phase));
});

var Circle = styled.div(_templateObject7, function (_ref6) {
  var size = _ref6.size,
      lightColor = _ref6.lightColor;
  return css(_templateObject8, size, size, lightColor);
});

var Moon = function Moon(_ref7) {
  var size = _ref7.size,
      rotation = _ref7.rotation,
      darkColor = _ref7.darkColor,
      lightColor = _ref7.lightColor,
      phase = _ref7.phase,
      border = _ref7.border,
      props = objectWithoutProperties(_ref7, ['size', 'rotation', 'darkColor', 'lightColor', 'phase', 'border']);

  return React.createElement(
    Wrapper,
    _extends({
      darkColor: darkColor,
      rotation: rotation,
      size: size,
      border: border
    }, props),
    React.createElement(
      Half,
      { size: size, isVisible: phase >= 0.5 },
      React.createElement(Circle, { darkColor: darkColor, lightColor: lightColor, size: size })
    ),
    React.createElement(Difference, {
      darkColor: darkColor,
      lightColor: lightColor,
      size: size,
      phase: phase
    }),
    React.createElement(
      Half,
      { size: size, invert: true, isVisible: phase <= 0.5 },
      React.createElement(Circle, { darkColor: darkColor, lightColor: lightColor, size: size })
    )
  );
};

Moon.propTypes = {
  size: PropTypes.number,
  rotation: PropTypes.string,
  darkColor: PropTypes.string,
  lightColor: PropTypes.string,
  phase: PropTypes.Number,
  border: PropTypes.string
};

Moon.defaultProps = {
  size: 80,
  darkColor: 'black',
  lightColor: 'white',
  rotation: 0,
  phase: 0.16,
  border: '4px solid black'
};

export default Moon;
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ../dist/index.es.js
// module id = 20
// module chunks = 0